import React, { useContext, useState } from "react";
// imported components

import AuthContext from "../../Contexts/Autenticacion/authContext";
import IconMenu from "../../img/icons/menu.svg";
//Custom Components
import CardGasto from "./CardGasto";
import FormIngresarGasto from "./FormIngresarGasto";
//Context
import GastosContext from "../../Contexts/Gastos/gastosContext";
import Loading from "../Utilities/Loading";

const Dashboard = () => {
  const [state, setstate] = useState({
    animacion: null,
  });
  const { usuario } = useContext(AuthContext);
  const { gastos } = useContext(GastosContext);

  const onClick = () => {
    if (state.animacion) {
      setstate({ animacion: null });
      return;
    }
    setstate({ animacion: "boton-gasto-push" });
    setTimeout(() => {
      setstate({ animacion: null });
    }, 200);
  };
  console.log(state.animacion);

  return (
    <div className="min-vh-100 w-100 container mt-4">
      <div className="row pb-5 ">
        {usuario ? (
          <h3 className="lead  ">
            Bienvenido{" "}
            <span className="text-capitalize">{usuario.username} </span>
          </h3>
        ) : null}
      </div>
      <div className="row ">
        <div className="col-lg-8 d-flex justify-content-center flex-wrap p-0 ">
          {gastos.length === 0 ? (
            <Loading />
          ) : (
            <>
              {gastos.map((data) => (
                <CardGasto gasto={data} />
              ))}
            </>
          )}
        </div>
        <div className="col-lg-4 d-flex justify-content-center align-items-start   ">
          <div className="d-none d-md-block">
            <FormIngresarGasto target={""} />
          </div>

          <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered bg-transparent">
              <div class="modal-content  justify-content-center bg-transparent">
                <div class="modal-body">
                  <FormIngresarGasto target={"exampleModal"} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" fixed-bottom row d-md-none justify-content-end  p-2">
          <div
            className={`App boton-gasto  rounded-circle mr-5 ${state.animacion}`}
            onClick={onClick}
          >
            <img
              onClick={onClick}
              src={IconMenu}
              className=" w-100 "
              alt=""
              data-toggle="modal"
              data-target="#exampleModal"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
